import React from 'react';
import { Container } from './styles';

const NotFoundScreen = () => {
  return (
    <Container>
      <div className='content'>
        <div className='errorCode'>404</div>
        <h1 className='title'>Page Not Found</h1>
        <p className='message'>
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <a href="/" className='homeLink'>
          Return to Homepage
        </a>
      </div>
    </Container>
  );
};

export default NotFoundScreen;